<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-22 23:53:33
 * @LastEditors: Merlin
 * @LastEditTime: 2024-06-10 10:33:36
 * @FilePath: /gamefi/components/Casino/GameSettings/Button/Fast.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <GameSettingsButtonWrapper
        :tool-tip="$t('waves.calc_roiTitle')" 
        anchor="top middle"
        self="bottom middle"
        @click="onClick()"
    >
        <IconSvgUse
            size="16px"
            use="icon-calculator"
        />
    </GameSettingsButtonWrapper>
</template>

<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';

const t = useTranslation();
// const props = defineProps({
//     modelValue: { // 目前没有用到 
//         type: Boolean,
//         default: false,
//     },
// });

// const emit = defineEmits(['update:modelValue']);

const onClick = () => {
    // emit('update:modelValue', !props.modelValue);
    
};
</script>
